import { RouteObject } from "react-router-dom";
import { performanceRoutes } from "./performance/routes";
import { callCenterDashboardRoutes } from "./callCenterDashboard/routes";
export interface CallCenterRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: CallCenterRoute[];
}
export const callCenterRoutes: CallCenterRoute[] = [
  ...performanceRoutes,
  ...callCenterDashboardRoutes,
];
